import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BasketComponent } from './basket.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';



@NgModule({
  providers: [LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/shopping-cart', component: BasketComponent, canActivate:[LanguageInterceptor] },
      { path: ':language/carrito', component: BasketComponent, canActivate:[LanguageInterceptor] },
      { path: ':language/panier-achats', component: BasketComponent, canActivate:[LanguageInterceptor] },
      { path: ':language/carrello', component: BasketComponent, canActivate:[LanguageInterceptor] },
      { path: ':language/warenkorb', component: BasketComponent, canActivate:[LanguageInterceptor] },      
    ])
  ]
})
export class BasketRoutingModule { }
